/** Nicknames for the Spin button. Plain, badminton-flavoured, 14 characters at most. */
export const SPIN_NICKNAMES: readonly string[] = [
  "Shuttle Run", "Cork Head", "Feather Duster", "Net Kill", "Drive Time", "Cross Court", "Jump Smash",
  "Slice of Life", "Service Fault", "The Tumbler", "Round the Head", "Flat Drive", "Hairpin", "Clear Out",
  "Rear Court", "Short Serve", "Mixed Doubles", "Baseline", "Wood Shot", "Frame Job", "Tin Feathers",
  "The Lifter", "Net Rusher", "Half Smash", "Stick Smash", "Body Shot", "Second Serve", "Side Out",
  "Love All", "Game Point", "Match Point", "String Theory", "Loose Grip", "Air Shot",
];

/** A nickname from the list that nobody is using and that is not the one showing now. */
export function spinNickname(taken: ReadonlySet<string>, current: string, max: number): string {
  const fits = SPIN_NICKNAMES.filter((n) => n.length <= max && n !== current);
  const free = fits.filter((n) => !taken.has(n.toLowerCase()));
  const from = free.length ? free : fits;
  return from[Math.floor(Math.random() * from.length)] ?? current;
}
